import { type ReactNode } from "react"

import { Card, CardContent } from "@/components/ui/card"
import { StepperCardHeader } from "@/components/ui/stepper"

export function BaseGeneratorComponent({ children }: { children: ReactNode }) {
  return (
    <Card className="relative mx-auto box-border max-w-xl border-t-8 border-primary shadow-2xl ">
      <StepperCardHeader />
      <CardContent className="sm:px-12">{children}</CardContent>
    </Card>
  )
}
